// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__O9qyZ","content":"styles_content__azXQF"};